import { IStateInit } from "@gtmhub/core/routing";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { ICollection } from "@gtmhub/models";
import { IScope, ITimeoutService, IPromise } from "angular";
import { IRole, RolesActions, RoleService } from "..";
import { IModalService } from "angular-ui-bootstrap";
import { INgRedux } from "@gtmhub/state-management";

interface IRolesScope extends IScope {
  indicators: {
    loading: boolean;
    deleting: boolean;
  };
  roles: ICollection<IRole>;
  openRoleDeletionDialog(role: IRole, index: number): void;
  isSystem(role: IRole): boolean;
}

export class RolesCtrl implements IStateInit {
  public static $inject = ["$scope", "$timeout", "RoleService", "UIErrorHandlingService", "$uibModal", "$ngRedux", "RolesActions"];

  constructor(
    private $scope: IRolesScope,
    private $timeout: ITimeoutService,
    private roleService: RoleService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $uibModal: IModalService,
    private $ngRedux: INgRedux,
    private rolesActions: RolesActions
  ) {
    this.$scope.$on("rolesChanged", this.onRolesChanged);
    this.$scope.openRoleDeletionDialog = this.openRoleDeletionDialog;
    this.$scope.isSystem = this.isSystem;
    this.$scope.indicators = {
      loading: false,
      deleting: false,
    };
  }

  public stateInit(): IPromise<unknown> {
    return this.init();
  }

  private init = (): IPromise<unknown> => {
    return this.loadRoles();
  };

  private onRolesChanged = () => {
    this.loadRoles();
  };

  private openRoleDeletionDialog = (role: IRole, index: number): void => {
    const modalInstance = this.$uibModal.open({
      template: `<delete-role role='${JSON.stringify(role)}' cancel-cb="$dismiss()" delete-role-cb="$close(true)"></delete-role>`,
      windowClass: "medium",
    });

    modalInstance.result.then((deleteRole: boolean) => {
      if (deleteRole) {
        this.deleteRole(role, index);
      }
    });
  };

  private deleteRole = (role: IRole, index: number) => {
    this.$scope.roles.items[index].ui = {};
    this.$scope.roles.items[index].ui.deleting = true;

    this.roleService.deleteRole(role.id).then(
      () => {
        this.$scope.roles.items[index].ui.deleted = true;
        this.$ngRedux.dispatch(this.rolesActions.removeRole(role.id));

        this.$timeout(() => {
          const newCollection: IRole[] = [];

          for (const oldRole of this.$scope.roles.items) {
            if (oldRole.id === role.id) {
              continue;
            }

            newCollection.push(oldRole);
          }

          this.$scope.roles.items = newCollection;
        }, 500);
      },
      (err) => this.uiErrorHandlingService.handleModal(err)
    );
  };

  private isSystem = (role: IRole): boolean => {
    return !role.accountId;
  };

  private loadRoles = (): IPromise<unknown> => {
    this.$scope.indicators.loading = true;

    return this.roleService.getRoles().then(
      (roles) => {
        this.$scope.indicators.loading = false;

        this.$scope.roles = roles;
      },
      (err) => this.handleIndicatorError(err, "loading")
    );
  };

  private handleIndicatorError = <E>(err: E, indicator: string, inline = false): void => {
    this.uiErrorHandlingService.handleIndicator(err, { indicator, inline });
  };
}
